export default {"src":"/_next/static/media/logomark-white.eb004718.svg","height":24,"width":93,"blurWidth":0,"blurHeight":0};